import React from 'react'

function SecondaryButton({
  onClick,
  ariaLabel,
  text,
  className,
  large,
  icon,
  disabled,
  small
}) {
  return (
      <div className={`${className} min-w-144`}>
      <button onClick={onClick} disabled={disabled} aria-label={ariaLabel} className={`${disabled ? 'text-gray-300 cursor-default' : 'text-secondary hover:bg-light'} flex items-center justify-center bg-white border border-gray-300 rounded ${!large &&  'py-1.5 px-2'} ${small && 'py-3 px-2 text-sm'} ${large && 'py-3 px-2 text-lg'} w-full`}>
          {icon &&
          <div className='mr-1'>
            {icon}
          </div>}
          {text}
      </button>
    </div>
  )
}

export default SecondaryButton
